
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import { useContext, useMemo, useState } from 'react';
import AuthContext from '../contexts/AuthContext';
import UserContext from '../contexts/UserContext';
import { headerRoutes } from '../config/pageRoutes';
import { Link } from 'react-router-dom';
import TransparentIconButton from '../common/TransparentIconButton';
import MobileHeaderRow from './MobileHeaderRow';
import MobileHeaderButton from './MobileHeaderButton';
import { useTranslation } from 'react-i18next';
import SideHeaderLangSelector from './SideHeaderLangSelector';

export default function MobileHeader() {
    const { t } = useTranslation();
    const { logout } = useContext(AuthContext);
    const { user, selectedRestaurant } = useContext(UserContext);
    const [menuOpen, setMenuOpen] = useState(false);

    const displayedPages = useMemo(() => {
        const relevantRoles = user.roles
            .filter(role => role.restaurantSetting != null && role.restaurantSetting.restaurantShortName === selectedRestaurant?.restaurantShortName)
            .map(role => role.type);
        const routes = headerRoutes.filter(route => {
            if (relevantRoles.some(role => route.roles.includes(role))) {
                return true;
            }
            return false;
        });
        return routes;
    }, [selectedRestaurant]);

    return (
        <div className="bg-primary-dark text-white h-14 flex justify-between items-center p-4">
            <div className="w-[43px]">

            </div>
            <h1 className='text-center'>{"QuickPick"}</h1>
            <TransparentIconButton onClick={() => setMenuOpen(true)}>
                {menuOpen ? <CloseIcon fontSize={"large"} /> : <MenuIcon fontSize={"large"} />}
            </TransparentIconButton>
            <Drawer
                anchor='right'
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
                PaperProps={{
                    className: 'mt-14 w-full'
                }}
                ModalProps={{
                    BackdropProps: {
                        invisible: true, // Eltávolítja a háttér elsötétítését
                    },
                    keepMounted: false
                }}
            >
                <div className="h-full pb-14 w-full bg-primary-dark text-white flex flex-col gap-2 p-4">
                    {displayedPages.map(route => (
                        <MobileHeaderRow
                            key={route.mainRoute.path}
                            title={route.title}
                            icon={route.icon}
                            route={route.mainRoute.path}
                            onClick={() => setMenuOpen(false)}
                            isPremiumFeature={route.isPremiumFeature}
                        />
                    ))}
                    <MobileHeaderButton
                        icon={<LogoutIcon />}
                        title={t("navigation.logout")}
                        onClick={() => logout()}
                    />
                    <div className="grow flex flex-col justify-end">
                        <SideHeaderLangSelector isExpanded={false} />
                    </div>
                </div>
            </Drawer>
        </div>
    );
}